import styled from 'styled-components';
import { breakpoints } from '../../../../../styles/theme';
import { StockModelCardHeaderStyled } from '../StockModelCardHeaderStyled';
import { rem } from 'polished';

export const StockModelCardHeaderStyledAP = styled(StockModelCardHeaderStyled)`
    .stockModelCard-header {
        &--demoInfo {
            color: ${({ theme }) => theme.colors.grey17};
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
        }
    }
`;
